<template>
  <div class="hello">
   
        <div v-for="(item, index) in text" :key="index" :style="color">
          <div class="bottom">
            {{ item }}
          </div>
        </div>
 <div class="bottomx" :style="color">
      {{ texts }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Bottom",
  data() {
    return {
      
    };
  },
  props: {
 
  
    text: Array,
    color:String,
    texts: String,


  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.bottom {
  font-size: 10px;
 
  line-height: 14px;
  text-align: center
}
.bottomx {
   font-size: 10px;
  text-decoration-line: underline;
}
.hello{
  padding-bottom: 10px;
}
</style>
